import { Link, Typography } from '@mui/material';

import { PageWrapper } from '@/components/PageWrapper';

export function Contact() {
  return (
    <PageWrapper>
      <Typography>
        Trafficon Software GmbH
        <br />
        Firmensitz Salzburg
        <br />
        <br />
        Strubergasse 26
        <br />
        5020 Salzburg
        <br />
        +43 662 46 11 02-0
        <br />
        <Link
          href="mailto:info@trafficon.eu"
          sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, color: 'text.primary' }}
        >
          info@trafficon.eu
        </Link>
      </Typography>
    </PageWrapper>
  );
}
